import {GET, handleRequest, handleSolutionCheckRequest, performRequestWithNoResponse, POST} from "./ApiService";

export default class RestService {

    static checkTask(securityCode, assignmentId, taskCodeToCheck) {
        return handleSolutionCheckRequest(POST, `/test/${securityCode}/assignment/${assignmentId}/check`,
            taskCodeToCheck, {"Content-Type": "text/plain"});
    }

    static saveTask(securityCode, assignmentId, taskCodeToSave) {
        return performRequestWithNoResponse(POST, `/test/${securityCode}/assignment/${assignmentId}/submit`,
            taskCodeToSave, {"Content-Type": "text/plain"});
    }

    static saveFeedback(securityCode, feedbackToSave) {
        return performRequestWithNoResponse(POST, `/test/${securityCode}/submitFeedback`, feedbackToSave);
    }

    static getTestInfo(securityCode) {
        return handleRequest(GET, `/test/${securityCode}`);
    }

    static getNextUnsolvedAssignment(securityCode) {
        return handleRequest(POST, `/test/${securityCode}/next_unsolved_assignment`);
    }
}

